import { useSelector } from 'react-redux';

import { useConsultantChatHost } from './useConsultantChatHost';
import { consultantChatIdSelector } from '../../selectors/consultantChat';
import { getRegionId } from '../../selectors/newbuilding';
import { getGaLabel } from '../../selectors/analytics';
import { selectDefaultProductsData } from '../../selectors/analytics/getProductsData';

interface IParams {
  isChatOpened: boolean;
}

export const useConsultantChatUrl = ({ isChatOpened }: IParams): string | undefined => {
  const chatHost = useConsultantChatHost();
  const chatId = useSelector(consultantChatIdSelector);
  const gaLabel = useSelector(getGaLabel);
  const regionId = useSelector(getRegionId);
  const product = useSelector(selectDefaultProductsData);
  const gaProductsData = [product];
  const gaProducts = JSON.stringify(gaProductsData);

  if (!isChatOpened) {
    return undefined;
  }

  return (
    `${chatHost}/dialogs/?hostType=frame&chatId=${chatId}` +
    `&region=${regionId}` +
    `${gaProducts ? '&gaProducts=' + encodeURIComponent(gaProducts) : ''}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    `&source=CardJK&pageType=CardJK`
  );
};
